const getPropsByKeyPath = (obj, key) => {
    try{
        return eval(`obj.${key}`);
    }catch(e){
        return undefined;
    }
}
export default (obj, props) => {
    const add = (key, value) => {
        let path = key.replace(/(\[([^\'\"])*?\])/g,".$2").replace(/(\[[\'\"]([^\'\"]+)[\'\"]\])/g,".$2").split(".");
        let len = path.length;
        let node = obj;
        for(let p of path){
            let i = path.indexOf(p);
            if (i >= len - 1 ){
                node[p] = value;
                return ;
            }else{
                let t = path[i + 1];
                node[p] = node[p] !== undefined ? node[p] : (/^\d+$/.test(t) ? [] : {});
                node = node[p];
            }
        }
    }
    //处理serials[].label这种情况
    const extend = (key) => {
        let res = [];
        if (/\[\]/.test(key)){
            let [nextKey] = key.split("[]");
            let arr = getPropsByKeyPath(obj, nextKey); 
            if (Array.isArray(arr)){
                if (arr.length === 0){
                       let r =  extend(key.replace(nextKey + "[]", nextKey + "[" + 0 +"]"));
                       res = [...res, ...r];
                }else{
                    for(let i in arr){
                        let r = extend(key.replace(nextKey + "[]", nextKey + "[" + i +"]"));
                        res = [...res, ...r];
                    }
                }
            }else if(arr === undefined){
                res = [...res, key.replace(nextKey + "[]", nextKey + "[" + 0 +"]")]
            }
        }else{
            res.push(key);
        }
        return res;
    }
    for(let key in props){
        let v = props[key];
        let ks = extend(key);
        for(let k of ks){
            add(k, v);
        }
    }
    return obj;
}